module.exports = __webpack_public_path__ + "img/Aaron_O_28.3f0c129d.jpg";